var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSetting3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.83 18.5v-3.9c0-.41.34-.75.75-.75s.75.34.75.75v3.9c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.83 7.45V5.5c0-.41.34-.75.75-.75s.75.34.75.75v1.95c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.23 10.05a3.35 3.35 0 0 1 6.7 0c0 1.85-1.51 3.35-3.35 3.35a3.35 3.35 0 0 1-3.35-3.35zm1.5 0c0 1.02.83 1.85 1.85 1.85s1.85-.83 1.85-1.85-.84-1.85-1.85-1.85c-1.02 0-1.85.83-1.85 1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 18.5v-1.95c0-.41.34-.75.75-.75s.75.34.75.75v1.95a.749.749 0 1 1-1.5 0zM7.67 9.4V5.5c0-.41.34-.75.75-.75s.75.34.75.75v3.9a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07 13.95a3.35 3.35 0 1 1 6.7 0 3.35 3.35 0 0 1-6.7 0zm1.5 0c0 1.02.83 1.85 1.85 1.85s1.85-.83 1.85-1.85-.82-1.85-1.85-1.85c-1.02 0-1.85.83-1.85 1.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSetting3);
export default __webpack_public_path__ + "static/media/vuesax-outline-setting-3.23430b8f613a01e78e392f2e4f3a8059.svg";
export { ForwardRef as ReactComponent };